import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import NoFlowchartViewer from 'processes/graph-builder-processes/flowchart-viz/NoFlowchartViewer';
import ProcessTaskLineageViewer from 'processes/graph-builder-processes/flowchart-viz/ProcessTaskLineageViewer';
import {GRAY_LIGHTER} from 'ui-library/Colors';

interface MissingFlowchartProps {
  missingFlowchartMessage: string;
  rootTaskId?: never;
  taskId?: never;
}

export interface ProcessTaskFlowchartTabViewProps {
  missingFlowchartMessage?: never;
  rootTaskId: string;
  taskId: string;
}

export default function ProcessTaskFlowchartTabView(
  props: MissingFlowchartProps | ProcessTaskFlowchartTabViewProps
): JSX.Element {
  if (props.missingFlowchartMessage == null) {
    return (
      <div className={classNames(css(styles.tabBackground), 'react-tab-container')}>
        <ProcessTaskLineageViewer rootTaskId={props.rootTaskId} taskId={props.taskId} />
      </div>
    );
  } else {
    return (
      <div className={classNames(css(styles.tabBackground), 'react-tab-container')}>
        <NoFlowchartViewer message={props.missingFlowchartMessage} />
      </div>
    );
  }
}

ProcessTaskFlowchartTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';

const styles = StyleSheet.create({
  tabBackground: {
    background: GRAY_LIGHTER,
    padding: 0,
    maxHeight: '100%',
    overflow: 'hidden',
  },
});
